import { useMutation } from '@tanstack/react-query';

import { importFromText } from '../../../api/ai';

interface UseImportFromTextParams {
  insertionOrder: number;
  quizId: number;
  workspaceId?: string;
  workspaceQuizId?: string;
}

interface UseImportFromTextMutationParams {
  textQuestions: string;
  fileKey?: string;
}

export function useImportFromText({
  quizId,
  workspaceId,
  workspaceQuizId,
  insertionOrder,
}: UseImportFromTextParams) {
  return useMutation({
    mutationFn: ({
      textQuestions,
      fileKey,
      includeExplanation,
    }: {
      textQuestions?: string;
      fileKey?: string;
      includeExplanation?: boolean;
    }) =>
      importFromText({
        quizId: quizId,
        workspaceId: workspaceId,
        textQuestions: textQuestions,
        insertionOrder: insertionOrder,
        workspaceQuizId: workspaceQuizId,
        fileKey: fileKey,
        includeExplanation: includeExplanation,
      }),
  });
}
